import { render, staticRenderFns } from "./WelcomeBonusModal.vue?vue&type=template&id=857c144a"
import script from "./WelcomeBonusModal.vue?vue&type=script&lang=js"
export * from "./WelcomeBonusModal.vue?vue&type=script&lang=js"
import style0 from "./WelcomeBonusModal.vue?vue&type=style&index=0&id=857c144a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports